import React from 'react';

import GenetecVideoPlayer from './players/GenetecVideoPlayer';
import HLSVideoPlayer from './players/HLSVideoPlayer';
import WowzaVideoPlayer from './players/WowzaVideoPlayer';
import { VideoPlayerProps } from './types';
import KVDSVideoPlayer from './players/KVDSVideoPlayer/KVDSVideoPlayer';
import NativeVideoPlayer from './players/NativeVideoPlayer';

// TODO: Props should extend VideoStream
const VideoPlayer: React.FunctionComponent<VideoPlayerProps> = (props) => {
  const { url, className, streamType, controls, setShowPTZControls, retry, settings } = props;

  switch (streamType) {
    case 'KVDS':
      const {
        applicationName: groupName,
        streamName: kvdsStreamName,
        setStreamLoaded: kvdsStreamLoaded,
      } = props;
      if (!groupName || !kvdsStreamName) {
        console.warn('KVDS stream is missing group name or stream name.');
        return <></>;
      }
      return (
        <KVDSVideoPlayer
          controls={controls}
          url={url}
          applicationName={groupName}
          streamName={kvdsStreamName}
          className={className}
          setShowPTZControls={setShowPTZControls}
          retry={retry}
          setStreamLoaded={kvdsStreamLoaded}
        />
      );

    case 'WEBRTC':
      const { applicationName, streamName, setStreamLoaded } = props;
      if (!applicationName || !streamName) {
        console.warn('WEBRTC stream is missing application name or stream name.');
        return <></>;
      }
      return (
        <WowzaVideoPlayer
          controls={controls}
          url={url}
          applicationName={applicationName}
          streamName={streamName}
          className={className}
          setShowPTZControls={setShowPTZControls}
          retry={retry}
          setStreamLoaded={setStreamLoaded}
        />
      );
    case 'HLS':
      const { setStreamLoaded: setStreamLoadedHls } = props;
      return (
        <HLSVideoPlayer
          controls={controls}
          url={url}
          className={className}
          setShowPTZControls={setShowPTZControls}
          retry={retry}
          setStreamLoaded={setStreamLoadedHls}
        />
      );
    case 'Playback':
      return (
        <HLSVideoPlayer
          controls={controls}
          url={url}
          className={className}
          setShowPTZControls={setShowPTZControls}
          retry={retry}
          setStreamLoaded={() => {}}
        />
        // TODO doesn't work with HLS
        // <VideoPlayback
        //   controls={controls}
        //   url={url}
        //   className={className}
        //   playbackInfo={playbackInfo}
        //   retry={retry}
        // />
      );
    case 'GENETEC':
      const { setStreamLoaded: setStreamLoadedGenetec } = props;
      return (
        <GenetecVideoPlayer
          settings={settings}
          controls={controls}
          url={url}
          className={className}
          setShowPTZControls={setShowPTZControls}
          retry={retry}
          setStreamLoaded={setStreamLoadedGenetec}
        />
      );
    case 'Native':
      return <NativeVideoPlayer {...props} />;
  }

  console.warn('Could not determine a video player from the props..');
  return <></>;
};

export default React.memo<VideoPlayerProps>(VideoPlayer);
